const DCV_INSTRUCTION_USER_PREF_KEY = "+ignore-dcv-instruction"

export const getIfUserConfirmedDcvInstruction = () => {
  return localStorage.getItem(DCV_INSTRUCTION_USER_PREF_KEY) ?? false
}

export const setUserConfirmedDcvInstruction = () => {
  localStorage.setItem(DCV_INSTRUCTION_USER_PREF_KEY, JSON.stringify(true))
}
